<!--
 * @Author: your name
 * @Date: 2021-08-05 18:15:46
 * @LastEditTime: 2022-07-15 16:39:50
 * @LastEditors: piaopiao.huang
 * @Description: In User Settings Edit
 * @FilePath: \yelink-ecm-portal-web\src\layout\components\Sidebar\index.vue
-->
<template>
  <div :class="{'has-logo':showLogo}">
    <logo
      v-if="showLogo"
      :collapse="isCollapse"
    />
    <menu-search :routes="userRoutes" :status="menuStatus" :collapsed="isCollapse" />
    <el-scrollbar wrap-class="scrollbar-wrapper">
      <el-menu
        :default-active="activeMenu"
        :collapse="isCollapse"
        background-color="#fff"
        :text-color="variables.menuText"
        :unique-opened="false"
        :active-text-color="variables.menuActiveText"
        :collapse-transition="false"
        mode="vertical"
      >
        <sidebar-item
          v-for="route in userRoutes"
          :key="route.path"
          :item="route"
          :base-path="route.path"
        />
      </el-menu>

    </el-scrollbar>
  </div>
</template>

<script>
import { mapGetters } from 'vuex'
import Logo from './Logo'
import SidebarItem from './SidebarItem'
import MenuSearch from './MenuSearch'
import variables from '@/styles/variables.scss'
import { menuUser } from '@/api/user.js'
import store from '@/store/index'
import { resetRouter } from '@/router/index'
export default {
  components: { SidebarItem, Logo, MenuSearch },
  data() {
    return {
      userRoutes: [],
      menuStatus: 'loading'
    }
  },
  computed: {
    ...mapGetters([
      'sidebar'
    ]),
    activeMenu() {
      const route = this.$route
      const { meta, path } = route
      // if set path, the sidebar will highlight the path you set
      if (meta.activeMenu) {
        return meta.activeMenu
      }
      return path
    },
    showLogo() {
      return this.$store.state.settings.sidebarLogo
    },
    variables() {
      return variables
    },
    isCollapse() {
      return !this.sidebar.opened
    }
  },
  created() {
    this.$nextTick(() => {
      this.getMenuUser()
    })
  },
  methods: {
    // 菜单
    getMenuUser() {
      menuUser().then(res => {
        this.userRoutes = res.routes
        const permissions = res.permissions
        store.commit('account/setPermissions', permissions)
        store.commit('account/setRoutes', res.routes)
        localStorage.setItem('USER_ROUTER', JSON.stringify(res.routes))
        resetRouter(res.routes)
        this.menuStatus = 'ready'
      }).catch(() => {
        this.menuStatus = 'error'
      })
    }
  }
}
</script>
<style lang="less" scoped>
::v-deep .el-scrollbar {
  // border: 1px solid red;
  background-color: #ffffff;
}
::v-deep .sidebar-item {
  background-color: #ffffff;
}
</style>
